export function getErrorMessage(error: unknown, fallback: string | null = null): string | null {
  const visited = new Set<unknown>()

  const visit = (value: unknown, depth: number): string | null => {
    if (typeof value === "string") return value.trim() || null
    if (!value || typeof value !== "object" || depth > 4 || visited.has(value)) return null

    visited.add(value)
    const record = value as Record<string, unknown>
    return visit(record.message, depth + 1) ?? visit(record.error, depth + 1)
  }

  return visit(error, 0) ?? fallback
}
